import React from 'react';
import { Switch as BaseSwitch } from '@base-ui/react/switch';
import styled from '@emotion/styled';
import theme from '@/theme';

const Switch = ({
  checked,
  onCheckedChange,
  disabled,
  label,
}: {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  label: string;
}) => (
  <StyledRoot
    checked={checked}
    onCheckedChange={onCheckedChange}
    disabled={disabled}
    aria-label={label}
  >
    <StyledThumb />
  </StyledRoot>
);

export default Switch;

const StyledRoot = styled(BaseSwitch.Root)`
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  box-sizing: border-box;
  width: 40px;
  height: 24px;
  margin: 0;
  padding: 2px;
  border: 0;
  border-radius: ${theme.radii.circle}px;
  background-color: ${theme.colors.fieldBorder};
  cursor: pointer;
  transition: background-color 150ms;

  &[data-checked] {
    background-color: ${theme.colors.primary};
  }

  &[data-disabled] {
    opacity: 0.5;
    cursor: default;
  }

  &:focus-visible {
    outline: 2px solid ${theme.colors.primary};
    outline-offset: 2px;
  }
`;

const StyledThumb = styled(BaseSwitch.Thumb)`
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${theme.colors.white};
  transition: transform 150ms;

  &[data-checked] {
    transform: translateX(16px);
  }
`;
